export default __webpack_public_path__ + "static/media/leftImg.e5c1e876.png";